import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withRtl } from '../hoc';

import ShareIcon from '../icons/Share';
import style from './Share.scss';
import messages from '../../locale/messages';

const localMessages = defineMessages({
  sharePopupInfoText: {
    id: 'sharePopup.InfoText',
    defaultMessage: 'Copy and paste this link to share with others:',
    description: 'Share popup info text',
  },
});

class Share extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { open: props.open };
  }

  onKeyDown = event => {
    if (event.key === 'Escape') {
      this.handleClose();
    }
    this.handlePropagation(event);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handlePropagation = event => {
    if (this.props.stopPropagation) {
      event.stopPropagation();
    }
  };

  toggle = event => {
    const open = this.props.text ? !this.state.open : false;
    this.setState({ open });
    this.handlePropagation(event);
  };

  handleFocus = event => {
    event.target.select();
  };

  render() {
    const { text, left } = this.props;
    const { open } = this.state;

    const buttonClasses = classNames(style.shareButton, {
      'button--no-style': !open,
      button: open,
      [style.shareButtonNormal]: !open,
    });
    const boxClasses = classNames(style.box, { [style.boxLeft]: left });
    return (
      <div role="presentation" className={style.root} onKeyDown={this.onKeyDown} onClick={this.handlePropagation}>
        <button onClick={this.toggle} className={buttonClasses}>
          <ShareIcon size="16px" fill={open ? '#FFF' : '#024CBC'} />
          &nbsp;
          <FormattedMessage {...messages.generalStringShare} />
        </button>
        {open && (
          <Fragment>
            <div className={boxClasses}>
              <div className={style.text}>
                <FormattedMessage {...localMessages.sharePopupInfoText} />
              </div>
              <input
                ref={input => input && input.focus()}
                className={style.input}
                value={text}
                onFocus={this.handleFocus}
                readOnly
              />
            </div>
            <div className={style.modalBackground} role="presentation" onClick={this.toggle} />
          </Fragment>
        )}
      </div>
    );
  }
}

Share.propTypes = {
  text: PropTypes.string,
  open: PropTypes.bool,
  // by default, the box is positioned with right: 0 relative to the container
  // the left prop is used to position it with left: 0 instead
  left: PropTypes.bool,
  stopPropagation: PropTypes.bool,
};

Share.defaultProps = {
  text: null,
  open: false,
  left: false,
  stopPropagation: false,
};

export default withRtl(style)(withStyles(style)(injectIntl(Share)));
